import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import Menu from "./InstructorMenu";
// import AssignmentExam from "./pages/AssignmentExam";
import SwitchAttendance from "./pages/Attendance/SwitchAttendance";
import SwitchCourseTab from "./pages/CourseBoard/SwitchCourseTab";
import CourseBoard from "./pages/CourseBoard/index.js";
import DynamicProfile from "./pages/DynamicProfile";
// import EditAssignment from "./pages/EditAssignment";
// import EditExam from "./pages/EditExam";
import FriendsPage from "./pages/FriendsPage";
import HelpPage from "./pages/HelpPage";
import Profile from "./pages/Profile";
// import AddEditGenerate from "./pages/ProgressCard/AddEditGenerate";
// import SwitchReportCard from "./pages/ProgressCard/SwitchReportCard";
// import ViewEditProgressCard from "./pages/ProgressCard/ViewEditProgressCard";
// import ViewReportTemplate from "./pages/ProgressCard/ViewReportTemplate.js";
// import ViewTemplateHistory from "./pages/ProgressCard/ViewTemplateHistory";
import Schedule from "./pages/Schedule/index.js";
import Settings from "./pages/Settings/index.js";
import InstructorMessagePage from "./pages/message/index.js";
import InstructorClassBroadcast from "./pages/message/InstructorClassBroadcast.js";
import SwitchClassAnnouncements from "./pages/message/SwitchClassAnnouncements.js";
import SwitchWhatsApp from "./pages/whatsapp/SwitchWhatsApp";
import TransportationStatus from "./pages/Transportation/TransportationStatus.js";
import ManageAssignmentV2 from "./pages/Assignment-V2/ManageAssignment.js";
// import ManageExam from "./pages/Exam/ManageExam.js";
import SwitchTabs from "./pages/instructorAttendance/SwitchTabs.js";
import InstructorLiveTracking from "./pages/Live tracking";

import ManageExamV2 from "./pages/Exam-V2/ManageExam.js";
// import AssignmentExam from "./pages/AssignmentExam";

import AddEditGenerateV2 from "./pages/ProgressCard-V2/AddEditGenerate";
import SwitchReportCardV2 from "./pages/ProgressCard-V2/SwitchReportCard";
import ViewEditProgressCardV2 from "./pages/ProgressCard-V2/ViewEditProgressCard";
import ViewReportTemplateV2 from "./pages/ProgressCard-V2/ViewReportTemplate.js";
import ViewTemplateHistoryV2 from "./pages/ProgressCard-V2/ViewTemplateHistory";
import SwitchExpense from "../admin/pages/components/manageexpenses/SwitchExpense";
import InstructorStock from "./pages/Stock/InstructorStock";
import SwitchTrip from "../admin/pages/components/managetrip/SwitchTrip";

const url = "/dashboard";

const InstructorRoutes = () => {
  return (
    <Routes>
      <Route path="instructor/menu" element={<Menu />} />
      <Route path="instructor/menu/profile" element={<Profile />} />
      <Route path="instructor/menu/friends" element={<FriendsPage />} />
      <Route path="instructor/menu/friends/:userId" element={<DynamicProfile />} />
      <Route path="instructor/help" element={<HelpPage />} />
      {/* <Route path="instructor/assignments-and-exams" element={<AssignmentExam />} /> */}
      {/* v1 submission-workflow screen, superseded by the Assignment-V2 marks grid */}
      {/* <Route path="instructor/assignment/edit/:id" element={<EditAssignment />} /> */}
      {/* <Route path="instructor/exam/edit/:id" element={<EditExam />} /> */}
      <Route path="instructor/menu/course-board" element={<CourseBoard />} />
      <Route path="instructor/:className/:classId/:subjectId" element={<SwitchCourseTab />} />
      <Route path="instructor/menu/attendance" element={<SwitchAttendance />} />
      {/* <Route path="instructor/menu/report/" element={<SwitchReportCard />} />
      <Route path="instructor/menu/report/template/:id" element={<ViewReportTemplate />} />
      <Route path="instructor/menu/student/:id/template/:id" element={<AddEditGenerate />} />
      <Route path="instructor/menu/student/template-history/:id" element={<ViewTemplateHistory />} />
      <Route path="instructor/menu/student/:id/template/:id/report/:id/" element={<ViewEditProgressCard />} /> */}
      <Route path="instructor/menu/instructor-attendance" element={<SwitchTabs />} />
      <Route path="instructor/menu/schedule/" element={<Schedule />} />
      <Route path="instructor/menu/setting/" element={<Settings />} />
      <Route path="instructor/home" element={<Profile />} />
      <Route path="instructor/menu/homework/" element={<InstructorClassBroadcast />} />
      <Route path="instructor/menu/diary" element={<DiaryBoard role="instructor" mode="senior" />} />
      <Route path="instructor/menu/message/" element={<InstructorMessagePage />} />
      <Route path="instructor/menu/class-announcements/" element={<SwitchClassAnnouncements />} />
      <Route path="instructor/menu/whatsapp" element={<SwitchWhatsApp />} />
      <Route path="instructor/menu/whatsapp/:tab" element={<SwitchWhatsApp />} />

      <Route path="instructor/menu/transportation/" element={<TransportationStatus />} />
      <Route path="instructor/menu/live-tracking/" element={<InstructorLiveTracking />} />
      {/* <Route path="instructor/menu/exam/" element={<ManageExam />} /> */}
      <Route path="instructor/menu/exam/" element={<ManageExamV2 />} />
      <Route path="instructor/menu/assignment/" element={<ManageAssignmentV2 />} />
      <Route path="instructor/menu/report/" element={<SwitchReportCardV2 />} />
      <Route path="instructor/menu/report/template/:id" element={<ViewReportTemplateV2 />} />
      <Route path="instructor/menu/student/:id/template/:id" element={<AddEditGenerateV2 />} />
      <Route path="instructor/menu/student/template-history/:id" element={<ViewTemplateHistoryV2 />} />
      <Route path="instructor/menu/student/:id/template/:id/report/:id/" element={<ViewEditProgressCardV2 />} />
      <Route path="instructor/menu/expenses" element={<SwitchExpense />} />
      <Route path="instructor/menu/stock" element={<InstructorStock />} />
      <Route path="instructor/menu/consent-form/:tab" element={<SwitchTrip basePath="/dashboard/instructor/menu/consent-form" />} />

      <Route index element={<Navigate to={`${url}/instructor/home`} replace />} />
    </Routes>
  );
};

export default InstructorRoutes;
